<template>
  <div class="pb-5">
    <nav-bar/>
    <!-- <sidebar-toggle-button/> -->
    <div class="filter-button-group">
        <button v-if="hasFullAccess && !isViewer" id="addOrder" class="btn btn-kne-orange me-2" @click="openNewOrder()">
           <i class="fa fa-plus-circle fa-lg" aria-hidden="true" /> {{$t('OrderPending.sidebar.add_order')}}
        </button>
        <toggle-button-group
          :buttons="tabOptions"
          :activeButton="selectedOrderFilter"
          :handleClick="handleFilterButtonClick"
        />
        <div class="search-vins">
          <regular-textarea
              :value="searchVinsList"
              :rows="'1'"
              @input="searchVinsList = $event"
              type="text" :placeholder="'Search VINs'"/>
          <button class="btn btn-kne-orange" @click="searchVins">
            <i class="fa fa-search" />
          </button>
        </div>
    </div>

    <!-- Order status Counter -->
    <order-status-counter
      class="mx-2 mt-2"
      :filterResults="tableFilterResults.length ? tableFilterResults : filteredOrders"
      :processedArray="filteredOrders"
      :selectedStatus="selectedStatusFilter"
      @filter="handleStatusFilter">
    </order-status-counter>

    <table-listing
      :arrOfOrders="displayedOrders"
      :defaultFieldsObj="fieldsObj"
      :activeTab="'current'"
      :lateOrdersArr="lateOrders"
      :liste="liste"
      :isDateRoute="isDateRoute"
      :disableDefaultSort="false"
      :currentPageBtn="true"
      :isBillingBtn="true"
      @filterResultsUpdated="onFilterResultsUpdated"
    />

    <loading-render v-if="isLoading" />

    <new-order-modal
      v-if="isNewOrderModal"
      :isNewOrderModal="isNewOrderModal"
      :order="order"
      :addressbook="addressbook"
      :zoneData="zoneData"
      :vinsList="vinsList"
      @closeNewOrderModal="clear"
    />

    <search-vins-modal
      v-if="openSearchVins"
      :arrOfOrder="matchedVins"
      :isOpen="openSearchVins"
      @close-request="openSearchVins = false"
    />
  </div>
</template>

<script>
import Modal from '../module/interface-components/Modal.vue'
import regularCheckbox from '../module/basic-components/regularCheckbox.vue'
import regularDatalistDriver from '../module/basic-components/regularDatalistDriver.vue'
import regularTextarea from '../module/basic-components/regularTextarea.vue'
import regularSelect from '../module/basic-components/regularSelect.vue'
import hoverToolTip from '../module/basic-components/hoverToolTip.vue'
import Search from '../module/special-components/Other-components/Search.vue'
import TableElement from '../module/special-components/Table-component/Table-Element.vue'
import { dryBoxMixin } from '../../utils/dryBoxLabels'
import NewOrderModal from '../module/special-components/Modal-templates/NewOrder-modal.vue'
import ShortDispatchModal from '../module/special-components/Modal-templates/ShortDispatch-modal.vue'
import StatusChangeModal from '../module/special-components/Modal-templates/StatusChange-modal.vue'
import LateTimeExtensionModal from '../module/special-components/Modal-templates/LateTimeExtension-modal.vue'
import LoadingRender from '../module/special-components/Other-components/LoadingRender.vue'
import CustomDatePick from '../module/special-components/Custom-packages/Custom-DatePick.vue'
import CustomJsonExcel from '../module/special-components/Custom-packages/Custom-JsonExcel.vue'
import CreateNote from '../module/special-components/Other-components/CreateNote.vue'
import CreateOfferModal from '../module/special-components/Modal-templates/CreateOffer-modal.vue'
import searchVinsModal from '../module/special-components/Modal-templates/search-vins-modal.vue'

import {db} from '../../firebase'
import JsonExcel from 'vue-json-excel'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import SidebarToggleButton from '../module/interface-components/sidebarToggleButton.vue'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import DeliveryLocationDetails from '../module/special-components/Other-components/DeliveryLocationDetails.vue'
import DatePick from 'vue-date-pick'
import 'vue-date-pick/dist/vueDatePick.css'
import OrderStatusCounter from '../module/special-components/Other-components/OrderStatusCounter.vue'
import ToggleButtonGroup from '../module/special-components/Other-components/ToggleButtonGroup.vue'
import FilterZonesModal from '../module/special-components/Modal-templates/FilterZones-modal.vue'
import FeeSelector from '../module/basic-components/feeSelector.vue'

import TableListing from '../module/special-components/Table-component/Table-Listing.vue'
import { isWarningOrder, isLateOrder } from '../../constants/orderStatus'
import { isRegularOrder } from '@/inventory/inventorySelectors'

export default {
  name: 'orderCurrent',
  mixins: [dryBoxMixin],
  components: {
    LoadingRender,
    Modal,
    regularCheckbox,
    regularTextarea,
    regularSelect,
    hoverToolTip,
    FeeSelector,
    Search,
    regularDatalistDriver,
    searchVinsModal,
    JsonExcel,
    vueDropzone: vue2Dropzone,
    SidebarToggleButton,
    VueGoogleAutocomplete,
    DeliveryLocationDetails,
    DatePick,
    OrderStatusCounter,
    TableElement,
    NewOrderModal,
    ShortDispatchModal,
    CreateOfferModal,
    StatusChangeModal,
    CustomDatePick,
    CustomJsonExcel,
    CreateNote,
    ToggleButtonGroup,
    FilterZonesModal,
    LateTimeExtensionModal,
    TableListing
    },

  data () {
    return {
      isLoading: true,
      zoneData: {},
      searchVinsList: '',
      matchedVins: [],
      notFoundVins: [],
      openSearchVins: false,
      user: {
          name: '',
          address: '',
          city: '',
          zipCode: '',
          province: '',
          phone: '',
          nir: '',
          cigle: '',
          logo: ''
        },
      lateOrders: [],
      billingFields: { // For accounts that are not sageOne/sageID
        'Order': 'Order',
        'Ref': 'Ref',
        'Item': 'Item',
        'Date': 'Date',
        'Price': 'Price',
        'Description': 'Description',
        'Billing': 'Billing',
        'ToBeEmailed': 'ToBeEmailed',
        'Driver': 'Driver',
        'Tax': 'Tax'
      },
      VIN: '',
      MAKE: '',
      MODEL: '',
      YEAR: '',
      SIZE: '',
      vehicles: [],
      pricingAndDelay: [],
      pickupSave: false,
      deliverySave: false,
      billingSame: false,
      order: {
        comment: '',
        docs: '',
        datePromis: '',
        dateExpected: '',
        dateSignataire: '',
        signataire: '',
        latitude: 0.001,
        longitude: 0.001,
        fuelCharge: 0,
        make: '',
        model: '',
        nbDispatch: 0,
        numRef: '',
        payer: '',
        payerAddress: '',
        payerCity: '',
        payerContact: '',
        payerFax: '',
        payerName: '',
        payerPhone: '',
        payerEmail: '',
        payerPostcode: '',
        payerCountry: '',
        payerProvince: '',
        payerZone: '',
        payerZoneId: '',
        applyFuelCharge: true,
        billNum: '',
        receiver: '',
        receiverAddress: '',
        receiverCity: '',
        receiverContact: '',
        receiverFax: '',
        receiverName: '',
        receiverLat: 0,
        receiverLong: 0,
        receptionPhone: '',
        receptionEmail: '',
        receiverEmail: '',
        receiverPostcode: '',
        receiverCountry: '',
        receiverProvince: '',
        receiverPlaceId: '',
        receiverContacts: [],
        receiverZone: '',
        receiverZoneId: '',
        status: 'Processing',
        source: '',
        sageID: '',
        transmitter: '',
        transmitterAddress: '',
        transmitterCity: '',
        transmitterContact: '',
        transmitterFax: '',
        transmitterLat: 0,
        transmitterLong: 0,
        transmitterName: '',
        transmitterPhone: '',
        transmitterEmail: '',
        transmitterPostcode: '',
        transmitterCountry: '',
        transmitterProvince: '',
        transmitterPlaceId: '',
        transmitterContacts: [],
        transmitterZone: '',
        transmitterZoneId: '',
        warningTime: 0,
        lateTime: 0,
        transpCigle: '',
        transpName: '',
        vin: '',
        year: '',
        size: '',
        regularPrice: 0,
        price: 0,
        discount: 0,
        surplus: 0,
        fees: []
      },
      datalist: {
        pickup: '',
        pickupUid: '',
        delivery: '',
        deliveryUid: '',
        billing: '',
        billingUid: ''
      },
      fields: {
        '.key': '',
        numRef: '',
        source: '',
        vin: '',
        datePromis: '',
        dateSignataire: '',
        docs: '',
        creationDate: '',
        receiverName: '',
        transmitterName: '',
        payerName: '',
        status: '',
        driverName: ''
      },
      backup: {
        sageIDDelivery: ''
      },
      filterResults: [],
      // processing: [],
      addressbook: [],
      makeList: ['Acura', 'Alfa Romeo', 'AM General', 'AMC', 'Aston Martin', 'Audi', 'Bentley', 'BMW', 'Bugatti', 'Buick', 'Cadillac', 'Chevrolet', 'Chrysler', 'Daewoo', 'Daihatsu', 'Datsun', 'DeLorean', 'Dodge', 'Eagle', 'Ferrari', 'FIAT', 'Fisker', 'Ford', 'Genesis', 'Geo', 'GMC', 'Honda', 'HUMMER', 'Hyundai', 'INFINITI', 'Isuzu', 'Jaguar', 'Jeep', 'Karma', 'Kia', 'Lamborghini', 'Land Rover', 'Lexus', 'Lincoln', 'Lotus', 'Maserati', 'Maybach', 'Mazda', 'McLaren', 'Mercedes-Benz', 'Mercury', 'Merkur', 'MINI', 'Mitsubishi', 'Nissan', 'Oldsmobile', 'Panoz', 'Pininfarina', 'Plymouth', 'Pontiac', 'Porsche', 'Ram', 'Renault', 'Rolls-Royce', 'Saab', 'Saturn', 'Scion', 'Smart', 'Sterling', 'Subaru', 'Suzuki', 'Tesla', 'Toyota', 'Volkswagen', 'Volvo', 'Yugo'],
      selected: [],
      selectedWithOrderNo: [],
      selectedFull: [],
      selectedFull2: [],
      billing: false,
      isOdooBill: false,
      dispatch: false,
      vinPrinting: false,
      hideTitleonPrint: false,
      shortDispatch: false,
      quickEdit: false,
      quickPayerEdit: false,
      dispatchOrder: {
        chauffeur: '',
        chauffeurName: ''
      },
      customViews: [],
      selectedCustomView: '',
      autocompleteSearchFields: ['address_components', 'adr_address', 'formatted_address', 'formatted_phone_number', 'geometry', 'id', 'name', 'place_id', 'type', 'vicinity'],
      // 'utc_offset_minutes', 'url', 'photo', 'business_status', 'icon', 'scope', 'alt_id',
      badVin: false, // New Order, invalid VIN check
      vueGoogleAutocomplete: false,
      addressBookSearch: true,
      priceOrderLink: [], // This is to create a price/order link list for dispatches
      feedbackMessage: '',
      areAllOrdersSelected: false,
      selectedContactEmails: [],
      isNewOrderModal: false,
      isDistributedModal: false,
      isDeliveryLocationModal: false,
      isStatusEdit: false,
      lateTimeExtension: false,
      vehicleReadyModal: false,
      selectedOrder: {}, // For changing date in Short Dispatch
      isShortDispatchModal: false,
      isCreateOfferModal: false,
      fieldsObj: [
       {
         text: `<i class="fa fa-solid fa-clipboard" />`,
         mobileText: this.$t('OrderCurrent.survey'),
         type: 'survey',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.order'),
         type: '.key',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.reference'),
         type: 'numRef',
         value: ''
       },
       {
         text: this.fieldLabel('vin'),
         type: 'vin',
         value: ''
       },
       {
         text: this.fieldLabel('model'),
         type: 'model',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.pickup'),
         type: 'transmitterName',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.delivery'),
         type: 'receiverName',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.billing'),
         type: 'payerName',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.status'),
         type: 'status',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.driver'),
         type: 'driverName',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.eta'),
         type: 'eta',
         value: ''
       }
      ],
      spreadDate: '',
      selectedOrderFilter: Object.keys(this.$route.query).length ? 'date' : 'in_progress',
      orderFilterOptions: [
        { label: `${this.$t('OrderCurrent.sidebar.pending')}`, value: 'pending', route: '/OrderCurrent' },
        { label: this.$t('OrderCurrent.sidebar.current'), value: 'in_progress', route: '/OrderCurrent' },
        { label: this.$t('OrderCurrent.sidebar.delivered'), value: 'delivered', route: '/OrderDelivered' },
        { label: this.$t('OrderCurrent.sidebar.toBill'), value: 'tobill', route: '/ToBill' },
        { label: this.$t('OrderCurrent.sidebar.waiting'), value: 'waiting', route: '/Waiting' },
        { label: this.$t('OrderCurrent.sidebar.date'), value: 'date', route: '/OrderCurrent?newDate=true' },
        { label: this.$t('NavBar.transfer'), value: 'transfer', route: '/TransferCurrent' },
        { label: this.$t('OrderCurrent.sidebar.toVerify'), value: 'verify', route: '/verify' }
      ],
      visibleLateOrders: false,
      zones: [],
      pickZones: [],
      dropZones: [],
      filteredPickZones: [],
      filteredDropZones: [],
      originalProcessing: [],
      pendingAccounts: [],
      clientAccounts: {},
      showFilterZonesModal: false,
      lateOrdersPresent: false,
      disableDefaultSort: true,
      ordersListener: null,
      unlistedListener: null,
      unlistedOrderKeys: [],
      unlistedProcessing: null,
      showUnlistedOrders: false,
      selectedStatusFilter: '',
      tableFilterResults: []
    }
  },
  mounted () {
    db.ref('users/transporters').child(this.companyUID).once('value').then((snapshot) => {
      this.$store.commit('setUserInfo', snapshot.val() || false)
      this.user = snapshot.val()
    })
  },

  beforeRouteLeave (to, from, next) {
    this.$unbind('liste')
    this.$unbind('pending')
    this.$unbind('user')
    // allDeliveries is now managed by the store, no need to unbind

    next(true)
  },

  created () {
    this.initializePage()
  },

  methods: {
    initializePage () {
      console.log('initializing page..')
      this.isLoading = true

      // Subscribe to deliveries via store if not already subscribed
      if (!this.$store.state.deliveriesLoaded) {
        this.$store.dispatch('subscribeToDeliveries')
      }

      // Watch for deliveries to be loaded
      const unwatch = this.$watch(
        () => this.$store.state.deliveriesLoaded,
        async (loaded) => {
          if (loaded) {
            await this.fetchUnlistedOrders()
            this.isLoading = false
            unwatch()
          }
        },
        { immediate: true }
      )

      this.getZones()
      this.$bindAsArray('liste', db.ref('database/transporter/').child(this.companyUID).child('/liste'))
      // this.$bindAsArray('customViews', db.ref('database/transporter/').child(this.companyUID).child('/customViews'))
      this.$bindAsObject('user', db.ref('userInfos/').child(this.companyUID).child(this.uid))
      this.$bindAsArray('pending', db.ref('database/transporter/').child(this.companyUID).child('/unprocessed'))
      if (this.$route.query.newOrder) this.loadAddressBook()
    },
    searchVins () {
      if (!this.searchVinsList) return

      let toSearchVins = this.searchVinsList
        .split(/[\n,]+/)
        .map(v => v.trim())
        .filter(v => v.length > 0)

      let vinsMap = new Map(
        this.vinsList.map(v => [v.vin, v])
      )

      this.matchedVins = []
      this.notFoundVins = []

      toSearchVins.forEach(inputVin => {
        let exactMatch = vinsMap.get(inputVin)

        if (exactMatch) {
          this.matchedVins.push(exactMatch)
        } else {
          let partialMatches = this.vinsList.filter(o =>
            o.vin && o.vin.includes(inputVin)
          )

          if (partialMatches.length) {
            this.matchedVins.push(...partialMatches)
          } else {
            this.notFoundVins.push(inputVin)
          }
        }
      })

      this.openSearchVins = true

      if (this.notFoundVins.length) {
        this.checkArchiveForNotFound()
      }
    },
    checkArchiveForNotFound () {
      this.notFoundVins.forEach(vin => {
        const url = `https://archivesapi.keepneye.com/search/decode/search/${this.companyUID}/vin=${vin}`

        window.axios.get(url)
          .then(res => {
            const data = res.data

            if (data && data.deliveries && data.deliveries.length > 0) {
              const archivedDeliveries = data.deliveries
                .filter(isRegularOrder)
                .map(d => ({
                  ...d,
                  orderNumber: d.orderNb,
                  isArchived: true
                }))
              this.matchedVins.push(...archivedDeliveries)

              this.notFoundVins = this.notFoundVins.filter(v => v !== vin)
            }
          })
      })
    },

    async fetchUnlistedOrders () {
      const snapshot = await db.ref('database/wallfiles/transporter')
        .child(this.companyUID)
        .child('unlisted')
        .once('value')

      if (!snapshot.exists()) return

      this.unlistedOrderKeys = snapshot.val() || []

      this.unlistedProcessing = this.processing.filter(order =>
        this.unlistedOrderKeys.includes(order['.key'])
      )
    },
    handleStatusFilter (status) {
      this.selectedStatusFilter = status
    },
    onFilterResultsUpdated (results) {
      this.tableFilterResults = results
    },
    getVehicleType (id) {
      if (id === 2) {
        return 'light'
      }
      if (id === 3) {
        return 'medium'
      }
      if (id === 4) {
        return 'heavy'
      }
      if (id === 5) {
        return 'extra_heavy'
      }
      return 'not_standard'
    },

    handleFilterButtonClick (buttonName) {
      this.selectedOrderFilter = buttonName
      const selectedOption = this.tabOptions.find(option => option.value === buttonName)
      if (selectedOption && selectedOption.route) {
        this.$router.push(selectedOption.route)
      }
    },
    filterZones (pickZones, dropZones) {
        this.showFilterZonesModal = false
        this.filteredPickZones = pickZones
        this.filteredDropZones = dropZones

        let pickZonesLength = pickZones.length
        let dropZonesLength = dropZones.length

        if (!pickZonesLength && !dropZonesLength) {
          this.processing = this.originalProcessing
          return
        }
        this.processing = this.originalProcessing.filter(ord => {
           return (!pickZonesLength || pickZones.includes(ord.transmitterZoneId)) &&
                    (!dropZonesLength || dropZones.includes(ord.receiverZoneId))
        })
      },

      async getZones () {
        // Use zones from store
        if (!this.$store.state.zonesLoaded) {
          await this.$store.dispatch('subscribeToZones')
        }
        const storeZones = this.$store.state.zones
        if (!storeZones.length) return

        this.zoneData = storeZones.reduce((acc, zone) => {
          acc[zone.id] = zone
          return acc
        }, {})

        this.zones = storeZones.map(zone => ({
          value: zone.id,
          text: zone.zoneName
        }))

        this.pickZones = this.zones.filter(zone => !this.passedPickZones || this.passedPickZones.includes(zone.value))
        this.dropZones = this.zones.filter(zone => !this.passedDropZones || this.passedDropZones.includes(zone.value))
      },

    clearSelected () {
      this.selected = []
    },

    clearfeedbackMessage () {
      this.feedbackMessage = ''
    },

    openNewOrder () {
      this.loadAddressBook()
      this.isNewOrderModal = true
    },

    createOffer (order) {
      const offer = {
        id: Date.now() + Math.random() * 1000,
        dateCreated: '',
        infos: {
          billNum: order.billNum,
          creationDate: order.creationDate,
          dateSignataire: order.dateSignataire,
          make: order.make,
          model: order.model,
          price: order.price,
          receiver: order.receiver,
          receiverAddress: order.receiverAddress,
          receiverCity: order.receiverCity,
          receiverContact: order.receiverContact,
          receiverCountry: order.receiverCountry,
          receiverEmail: order.receiverEmail,
          receiverFax: order.receiverFax,
          receiverLat: order.receiverLat,
          receiverLong: order.receiverLong,
          receiverName: order.receiverName,
          receiverPhone: order.receiverName,
          receiverPlaceId: order.receiverPlaceId,
          receiverPostcode: order.receiverPostcode,
          receiverProvince: order.receiverProvince,
          regularPrice: order.regularPrice,
          size: order.size,
          source: order.source,
          transmitter: order.transmitter,
          transmitterAddress: order.transmitterAddress,
          transmitterCity: order.transmitterCity,
          transmitterContact: order.transmitterContact,
          transmitterCountry: order.transmitterCountry,
          transmitterEmail: order.transmitterEmail,
          transmitterFax: order.transmitterFax,
          transmitterLat: order.transmitterLat,
          transmitterLong: order.transmitterLong,
          transmitterName: order.transmitterName,
          transmitterPhone: order.transmitterPhone,
          transmitterPlaceId: order.transmitterPlaceId,
          transmitterPostcode: order.transmitterPostcode,
          transmitterProvince: order.transmitterProvince,
          transpCigle: order.transpCigle,
          transpName: order.transpName,
          trim: order.trim,
          vin: order.vin,
          weight: order.weight,
          year: order.year
        },
        provider: this.companyUID,
        comment: '',
        status: 'ACTIVE'
      }
      return offer
    },

    loadAddressBook () {
      console.log('Initializing addressbook')
      db.ref('database/transporter/' + this.companyUID + '/addressbook').once('value').then((snap) => {
        let addressbookArray = []
        snap.forEach((element) => {
          let item = element.val()
          item.key = element.key
          if (item.placeId && item.lat && item.long) {
            addressbookArray.push(item)
          }
        })
        this.addressbook = addressbookArray
      })
    },

    formatDate (date) {
      let fdate = new Date(date)
      fdate = fdate.getFullYear() + '-' + ('0' + (fdate.getMonth() + 1)).slice(-2) + '-' + ('0' + fdate.getUTCDate()).slice(-2)

      return fdate
    },

    randomPdfString (length) {
      var text = ''
      var possible = 'abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      for (var i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length))
      }
      return text + '.pdf'
    },

    print: function (order) {
      if (!order.isPrinted) {
        // db.ref('test2/transporter/' + this.companyUID + '/deliveries/' + order['.key']).update({'isPrinted': true})
        db.ref('database/transporter/' + this.companyUID + '/deliveries/' + order['.key']).update({'isPrinted': true})
      }
    },

    clear: function () {
      for (let attr in this.order) {
        this.order[attr] = ''
      }
      this.clearfeedbackMessage()
      this.dispatchOrder.chauffeur = ''
      this.dispatchOrder.chauffeurName = ''
      this.order.regularPrice = 0
      this.order.price = 0
      this.order.discount = 0
      this.order.surplus = 0
      this.order.fees = []
      this.order.status = 'Processing'
      this.order.latitude = 0.001
      this.order.longitude = 0.001
      this.order.nbDispatch = 0
      this.order.includedFuelCharge = false
      for (let attr in this.datalist) {
        this.datalist[attr] = ''
      }
      this.vehicles = []
      this.VIN = ''
      this.MAKE = ''
      this.MODEL = ''
      this.YEAR = ''
      this.SIZE = null // Car size check
      this.badVin = false // Valid vin check
      for (let attr in this.newCustomView) {
        this.newCustomView[attr] = ''
      }
      this.isNewOrderModal = false
    }
  },

  computed: {
    allDeliveries () {
      return this.$store.state.deliveries.filter(isRegularOrder)
    },
    processing () {
      return this.allDeliveries
        .filter(order =>
          order.status !== 'Drop' &&
          order.status !== 'to cancel' &&
          order.status !== 'Attente' &&
          order.status !== 'to finish'
        )
        .map(order => ({
          ...order,
          size: this.getVehicleType(order.size)
        }))
    },
    vinsList () {
      return this.allDeliveries
        .map(o => ({
          vin: o.vin,
          status: o.status,
          orderNumber: o['.key'],
          transmitterName: this.$realName(o, 'transmitter'),
          receiverName: this.$realName(o, 'receiver'),
          payerName: this.$realName(o, 'payer')
        }))
    },
    filteredOrders () {
      return this.showUnlistedOrders ? this.unlistedProcessing : this.processing
    },
    displayedOrders () {
      if (!this.selectedStatusFilter) {
        return this.processing
      }
      if (this.selectedStatusFilter === 'warning') {
        return this.processing.filter(order => isWarningOrder(order) && !isLateOrder(order))
      }
      if (this.selectedStatusFilter === 'late') {
        return this.processing.filter(order => isLateOrder(order))
      }
      if (this.selectedStatusFilter === 'isBilling') {
        return this.processing.filter(order => order.status === 'isBilling')
      }
      return this.processing.filter(order => order.status === this.selectedStatusFilter)
    },

    hasFullAccess () {
      return this.$store.state.userInfo.userType === 'full'
    },

    isViewer () {
      return this.$store.state.authorization.role === 'Viewer'
    },

    computed_newCount (newCount) {
      return newCount
    },
    companyUID () {
      return this.$store.state.authorization.company
    },
    uid () {
      return this.$store.state.user.uid
    },
    userInfo () {
      return this.$store.state.userInfo
    },
    isDateRoute () {
      return this.$route.query.newDate
    },
    currentCount () {
      return this.$store.state.deliveries.filter(order =>
        isRegularOrder(order) &&
        order.status !== 'Drop' &&
        order.status !== 'to cancel' &&
        order.status !== 'Attente' &&
        order.status !== 'to finish' &&
        !order.isBilling
      ).length
    },
    deliveredCount () {
      return this.$store.state.deliveries.filter(order =>
        isRegularOrder(order) && order.status === 'Drop' && !order.isBilling
      ).length
    },
    toBillCount () {
      return this.$store.state.deliveries.filter(order =>
        isRegularOrder(order) && order.isBilling === true
      ).length
    },
    waitingCount () {
      return this.$store.state.deliveries.filter(order =>
        isRegularOrder(order) && order.status === 'Attente' && !order.isBilling
      ).length
    },
    tabOptions () {
      return [
        { label: this.$t('OrderCurrent.sidebar.pending'), value: 'pending', route: '/OrderPending', count: this.pending ? this.pending.length : 0 },
        { label: this.$t('OrderCurrent.sidebar.current'), value: 'in_progress', route: '/OrderCurrent', count: this.currentCount },
        { label: this.$t('OrderCurrent.sidebar.delivered'), value: 'delivered', route: '/OrderDelivered', count: this.deliveredCount },
        { label: this.$t('OrderCurrent.sidebar.toBill'), value: 'tobill', route: '/ToBill', count: this.toBillCount },
        { label: this.$t('OrderCurrent.sidebar.waiting'), value: 'waiting', route: '/Waiting', count: this.waitingCount },
        { label: this.$t('OrderCurrent.sidebar.date'), value: 'date', route: '/OrderCurrent?newDate=true' },
        { label: this.$t('NavBar.transfer'), value: 'transfer', route: '/TransferCurrent' },
        { label: this.$t('OrderCurrent.sidebar.toVerify'), value: 'verify', route: '/verify' }
      ]
    }
  },

  watch: {
    billingSame: function (val) {
      var order = this.order
      if (!val) {
        order.payerAddress = ''
        order.payerCity = ''
        order.payerContact = ''
        order.payerFax = ''
        order.payerName = ''
        order.payerPhone = ''
        order.payerEmail = ''
        order.payerPostcode = ''
        order.payerProvince = ''
        order.payerCountry = ''
        order.sageID = ''
      } else {
        order.payerAddress = order.receiverAddress
        order.payerCity = order.receiverCity
        order.payerContact = order.receiverContact
        order.payerFax = order.receiverFax
        order.payerName = order.receiverName
        order.payerPhone = order.receiverPhone
        order.payerEmail = order.receiverEmail
        order.payerPostcode = order.receiverPostcode
        order.payerProvince = order.receiverProvince
        order.payerCountry = order.receiverCountry
        order.sageID = this.backup.sageIDDelivery || ''
        this.datalist.billing = ''
        this.datalist.billingUid = ''
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .dispatch-info-tab {
    display: flex;
    flex-flow: row;
  }

  .preBody {
    display: flex;
    justify-content: space-between;

  }
  .table thead th{
    border-bottom: 1px solid #eceeef;
    border-top: none;
  }
  #addOrder, #customView{
    position: relative;
  }

  .printed{
    background-color: #79cc79 !important;
    border-color: #79cc79 !important;
  }
  .kne-tab:hover{
    color: #f7941e !important;
  }
  .kne-tab.active{
    color: #f7941e !important;
  }
  th{
    resize: horizontal;
  }
  .view{
    padding-left: 11rem;
  }
  .sidebar{
    width: 10.5rem;
  }
  .current{
    border-left: 3px solid #f7941e;
  }
  #checkBox{
    width: 1.25rem;
    height: 1.25rem;
  }
  #fileIcon{
    margin-top: 0.70rem;
  }

  .fa-exclamation{
    margin-left: 0.25rem;
  }

  .input--missing {
    border: solid 1px;
    border-color: rgb(211, 116, 116);
    border-radius: 5px;
  }

  .toggleSwitch {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #priceSection label {
    margin-left: 1rem;
  }

  .newOrder__container--display {
    display: flex;
    flex-flow: row;
    width: 50%;
  }

  .newOrder__container--display-mobile {
    display: flex;
    flex-flow: column;
    width: 100%;
  }

  .document-date__container {
    display: flex;
    justify-content: space-between;
  }

  .document-date__container--mobile {
    flex-direction: column;
  }

  .document-date__item {
    width: 45%;
  }

  .document-date__item--mobile {
    width: 100%;
  }

  .document-date__button-red {
    background-color: rgb(255, 58, 58);
  }
  .icon-size {
    font-size: 1.5rem;
  }

  .flex-row {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .header-actions{
    display:flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }
  .fw-700{
    font-weight: 700;
  }
 
  .red, .red:focus, .red:hover {
    color: #ece7e7;
    background-color: #ad0001d1 !important;
  }
 
  .orange, .orange:focus {
    background-color: #ffa5009e !important;
    color: #353535
  }

  .yellow, .yellow:hover {
    background-color: #ffff00a3 !important;
  }

  .toggle-button-group button {
      border: 1px solid transparent;
      padding: 6px 16px;
      cursor: pointer;
      outline: none;
      background:white;
      border-left:1px solid rgba(201, 192, 192, .4);
      border-right: 1px solid rgba(201, 192, 192, .4);
  }

  .toggle-button-group button.active {
      background-color: #f7941e;
      color: white;
      border:1px solid transparent;
  }

  .uncheck {
    background-image: none !important;
    background-color: #fff !important;
  }

  .check {
    background-image: url('data:image/svg+xml;charset=utf8,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8"%3E%3Cpath fill="%23fff" d="M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z"/%3E%3C/svg%3E') !important;
    background-color: #0275d8 !important;
  }

  .search-vins {
    display: flex;
    align-items: center;
  }

  .search-vins > regular-input,
  .search-vins > .form-group {
    flex: 1 1 auto;
    min-width: 0;
  }

  .search-vins > regular-input input,
  .search-vins > .form-group input {
    width: 100%;
    box-sizing: border-box;
  }

  .search-vins button {
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.55rem 0.9rem;
    min-height: 40px;
    border-radius: 4px;
  }

  @media (max-width: 420px) {
    .search-vins {
      flex-direction: column;
      align-items: stretch;
    }

    .search-vins button {
      width: 100%;
    }
  }
</style>
